import React, { useRef } from 'react';
import styled from 'styled-components';
import { space, lineHeight, width } from 'styled-system';
import Text from '../Text';

const StyledTextarea = styled.textarea`
  ${width}
  ${space}
  ${lineHeight}
  background: white;
  border-radius: 20px;
  border: 0;
`;

const Label = styled(Text).attrs(() => ({
  as: 'label',
  variant: 'secondary',
  mb: 3,
}))`
  display: block;
`;

const TextArea = ({ label, ...props }) => {
  const ref = useRef();
  if (label) {
    return (
      <span>
        <Label htmlFor={ref.current}>{label}</Label>
        <StyledTextarea ref={ref} {...props} />
      </span>
    );
  }
  return <StyledTextarea {...props} />;
};

TextArea.defaultProps = {
  px: 4,
  py: 3,
};

export default TextArea;
